<template>
  <div class="carditem" :class="{isHidden:isHidden}">
    <div class="title" v-show="topinfo.title ? true : false" :class="{isDevop:bannerType==1,isOperate:bannerType==2,isBuild:bannerType==3,isHealth:bannerType==4}">{{topinfo.title}}</div>
    <div class="ranktitle" :class="{devtitle:bannerType==1,operatetitle:bannerType==2,buildtitle:bannerType==3,healthtitle:bannerType==4}" v-show="isHidden">{{topinfo.ranktitle}}</div>
    <div class="content">
      <slot name="echartitem"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      
    }
  },
  mounted(){
    // console.log(this.topinfo)
  },
  props:['topinfo','bannerType','isHidden']
}
</script>

<style  lang="stylus" scoped>
.carditem{
  width: 600px;
  margin: 0 auto;
  // margin-top: 40px;
  // border: solid 1px #d9d9d9;
  // border-bottom-left-radius: 20px;
  // border-bottom-right-radius: 20px;
  .devtitle{
    color: #7db8eb;
  }
  .operatetitle{
    color: #83db25;
  }
  .buildtitle{
    color: #e5a904;
  }
  .healthtitle{
    color: #b17d2d;
  }
  .isOperate{
    background-color:#E8F1BC;
  }
  .isDevop{
    background-color:#d7f2fc;
  }
  .isBuild{
    background-color:#f7f6d5;
  }
  .isHealth{
    background-color:#EFE3BB;
  }
  .title{
    width: 600px;
    height: 60px;
    border-radius: 30px;
    // border-top-right-radius: 20px;
    color: #000;
    text-align: center;
    line-height: 60px;
    font-size:28px;
    margin: 30px auto;
  }
  .content{
    border-bottom-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }
  .ranktitle{
    display:none;
  }
}
.isHidden{
  border: solid 1px #d9d9d9;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  margin-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  .title{
    display:none;
  }
  .ranktitle{
    // font-weight: 600;
    display:block;
    background-color:#f6f6f6;
    height:60px;
    line-height:60px;
    text-align:center;  
  }
}
</style>